import request from '@/utils/request'
const qs = require('qs')
export function listDataMasterKontak(data) {
  return request({
    url: '/master_kontak/list_data_master_kontak',
    method: 'POST',
    data: qs.stringify(data) // untuk array data post
  })
}



// WEBPACK FOOTER //
// ./src/api/reportMasterKontak.js